import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "\n          Name of candidate offered:\n        ", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "flex justify-end w-full" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = {
    key: 0,
    class: "ml-2"
};
const _hoisted_16 = { class: "lg:hidden" };
const _hoisted_17 = { class: "bg-white rounded-lg p-4 w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_OfferApprovalChat = _resolveComponent("OfferApprovalChat");
    const _component_form_layout = _resolveComponent("form-layout");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_form_layout, {
            "nav-item-config": _ctx.navItemConfig,
            "current-nav-item": _ctx.currentNavItem,
            "form-point": _ctx.formPoint,
            "form-data": _ctx.formData,
            "hide-action": _ctx.hideAction && !_ctx.currentUserIsAssigned,
            "display-header": _ctx.showApprovalSteps,
            "print-mode": _ctx.inPrintMode,
            "display-timeline": _ctx.showApprovalSteps ||
                _ctx.formData.currentStageName === 'offer.notifyMakeOffer' ||
                _ctx.formData.currentStageName === 'offer.notifyOfferSent' ||
                _ctx.formData.currentStageName === 'offer.complete',
            "display-footer": true,
            onSetCurrentNavItem: _ctx.setCurrentNavItem
        }, {
            pageTitle: _withCtx(() => [
                _createTextVNode("Approval to Recruit (ATR)")
            ]),
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.formData?.candidateName), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.currentStage?.displayName), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.formData.atr?.formOne?.hiringManagerEmail ??
                        _ctx.formData.currentAssigneeEmail), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.formData?.status), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                        (_ctx.currentStage?.stageName === 'offer.notifyCandidateSelected')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "\n            Please confirm that the terms of the offer have not changed\n          "))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        ((_ctx.profile?.ADMIN ||
                            _ctx.profile.H2R ||
                            _ctx.formData.requestedBy === _ctx.profile?.userID) &&
                            _ctx.formData.status !== 'CANCELLED')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-red-700 hover:bg-red-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.handleCancelOffer && _ctx.handleCancelOffer(...args)), ["prevent"]))
                            }, "\n            Cancel Offer\n          "))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.currentStage?.stageName === 'offer.notifyCandidateSelected')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-red-700 hover:bg-red-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.confirmOfferChanged && _ctx.confirmOfferChanged(...args)), ["prevent"]))
                            }, "\n            Terms have changed\n          "))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.currentStage?.stageName === 'offer.notifyCandidateSelected')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "ml-2 inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.confirmOffer && _ctx.confirmOffer(...args)), ["prevent"]))
                            }, "\n            Terms have not changed\n          "))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.hanldeReassign && _ctx.hanldeReassign(...args)))
                            }, "\n            Re-assign\n          ")
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            navFooter: _withCtx(() => [
                (!_ctx.editable &&
                    [
                        'offer.notifyHROpsReApproval',
                        'offer.notifyBudgetReApproval',
                    ].includes(_ctx.currentStage?.stageName) &&
                    (_ctx.currentUserIsAssigned || _ctx.profile.ADMIN))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                    }, "\n        Edit\n      ", 2))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentStage?.stageName === 'offer.notifyBudgetReApproval' &&
                    (_ctx.currentUserIsAssigned || _ctx.profile.ADMIN))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-full",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.approveReapproval && _ctx.approveReapproval(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.editable ? "Save Edits" : "Approve Budget Holder"), 1))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentStage?.stageName === 'offer.notifyMakeOffer' &&
                    (_ctx.currentUserIsAssigned || _ctx.profile.ADMIN))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-full",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.approveReapprovalHROps && _ctx.approveReapprovalHROps(...args)), ["prevent"]))
                    }, "\n        Approve HROps\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentStage?.stageName === 'offer.notifyHROpsReApproval' &&
                    (_ctx.currentUserIsAssigned || _ctx.profile.ADMIN))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-full",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.approveReapprovalHROps && _ctx.approveReapprovalHROps(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.editable ? "Save Edits" : "Approve HROps"), 1))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.currentUserIsAssigned || _ctx.profile.ADMIN) &&
                    _ctx.formData.currentStageName === 'offer.notifyH2RAdminAdded')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => (_ctx.handleConfirmLeaver && _ctx.handleConfirmLeaver(...args)))
                    }, "\n        Admin Approve Or More Info\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.currentUserIsAssigned || _ctx.profile.ADMIN) &&
                    _ctx.formData.currentStageName === 'offer.notifyHMMoreInfo')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[9] || (_cache[9] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRespondMoreInfo && _ctx.handleRespondMoreInfo(...args)))
                    }, "\n        Action\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.currentUserIsAssigned || _ctx.profile.ADMIN) &&
                    (_ctx.formData.currentStageName === 'offer.notifyBudgetReApproval' ||
                        _ctx.formData.currentStageName === 'offer.notifyHROpsReApproval'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "mt-2 w-full text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[10] || (_cache[10] =
                            //@ts-ignore
                            (...args) => (_ctx.handleReject && _ctx.handleReject(...args)))
                    }, "\n        Reject\n      "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.canPrint)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 7,
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[11] || (_cache[11] =
                            //@ts-ignore
                            (...args) => (_ctx.print && _ctx.print(...args)))
                    }, "\n        Print/Save to PDF\n      "))
                    : _createCommentVNode("", true)
            ]),
            main: _withCtx(() => [
                (_ctx.formData.atr)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentNavItem.component), {
                        key: 0,
                        atr: _ctx.formData.atr,
                        "atr-ready-to-submit": _ctx.atrReadyToSubmit,
                        "config-data": _ctx.configData,
                        "config-items": _ctx.configData,
                        "form-data": _ctx.formData[_ctx.currentNavItem.name] || _ctx.formData.atr[_ctx.currentNavItem.name],
                        data: _ctx.formData,
                        "show-approval-steps": _ctx.showApprovalSteps,
                        document: _ctx.formData,
                        status: _ctx.formData.status,
                        "disable-form": _ctx.editable && _ctx.currentNavItem.formPoint < 5 ? false : true,
                        editable: _ctx.editable,
                        "onUpdate:formData": _ctx.handleUpdateFormData,
                        "onUpdate:reset": _ctx.handleResetFormData,
                        onSubmitForm: _ctx.handleSubmitForm,
                        onSubmitAtr: _ctx.handleSubmitAtr
                    }, null, 40, ["atr", "atr-ready-to-submit", "config-data", "config-items", "form-data", "data", "show-approval-steps", "document", "status", "disable-form", "editable", "onUpdate:formData", "onUpdate:reset", "onSubmitForm", "onSubmitAtr"]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => (_ctx.openApprovalModal && _ctx.openApprovalModal(...args)))
                    }, "\n          Action\n        ")
                ])
            ]),
            printArea: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItemConfig, (comp) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: comp.name
                    }, [
                        (_ctx.formData.atr)
                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(comp?.component), {
                                key: 0,
                                atr: _ctx.formData.atr,
                                "form-data": _ctx.formData[comp?.name] || _ctx.formData.atr[comp?.name],
                                data: _ctx.formData,
                                "disable-form": true,
                                editable: false,
                                "show-approval-steps": _ctx.showApprovalSteps,
                                "config-items": _ctx.configData,
                                "config-data": _ctx.configData,
                                document: _ctx.formData,
                                status: _ctx.formData.status,
                                "atr-ready-to-submit": false
                            }, null, 8, ["atr", "form-data", "data", "show-approval-steps", "config-items", "config-data", "document", "status"]))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ]),
            timeline: _withCtx(() => [
                (_ctx.formData.activityList)
                    ? (_openBlock(), _createBlock(_component_activity_feed, {
                        key: 0,
                        "activity-list": _ctx.formData?.activityList
                    }, null, 8, ["activity-list"]))
                    : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                    (_ctx.formData.shortId)
                        ? (_openBlock(), _createBlock(_component_OfferApprovalChat, {
                            key: 0,
                            "form-data": _ctx.formData,
                            "doc-type": "OFFER"
                        }, null, 8, ["form-data"]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }, 8, ["nav-item-config", "current-nav-item", "form-point", "form-data", "hide-action", "display-header", "print-mode", "display-timeline", "onSetCurrentNavItem"]),
        _createTextVNode(),
        (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _ctx.handleModalClose
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("ATR Approval")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("What would you like to do with this ATR?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[13] || (_cache[13] =
                            //@ts-ignore
                            (...args) => (_ctx.handleApproveAtr && _ctx.handleApproveAtr(...args)))
                    }, "\n        Approve\n      ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showRejectModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 1,
                onClose: _ctx.handleRejectModalClose
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_ExclamationIcon, {
                        class: "h-12 w-12 bg-white text-red-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Reject Offer")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("Are you sure you want to reject this offer? This action cannot be\n      undone.")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[14] || (_cache[14] =
                            //@ts-ignore
                            (...args) => (_ctx.reject && _ctx.reject(...args)))
                    }, "\n        Reject\n      ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true)
    ], 64));
}
